import { Component, OnInit } from '@angular/core';
import { GridOptions } from "ag-grid/main";
import { Globals } from '../../globals';
import { Router } from '@angular/router';
// import { setTimeout } from 'timers';
import { TemplatesService } from 'app/services/template/TemplatesService';

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
    //data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridApi360;
    gridApiStandard;
    gridApiStandard360;

    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;
    loading: boolean = true;

    rowSelection: string;

    canEdit: boolean = false;
    canDelete: boolean = false;

    currentRowIndex: number;

    standardDataHeaders: any[];
    //enableFilter: boolean = false;
    //filters: string[] = ['Name', 'Purpose', 'AssessmentType'];

    myTemplatesRegularData: string[] = [];
    myTemplates360Data: string[] = [];
    standardRegularData: string[] = [];
    standard360Data: string[] = [];

    currentSelectedTab: number = 2;

    constructor
        (
            private router: Router,
            private _Globals: Globals,
            private _TemplatesService: TemplatesService
        ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();
        this.standardDataHeaders = this.standardDataCreateHeaders();

        //this.getEmailTemplates();
        //this.getGlobalEmailTemplates();

        //my templates
        this.getEmailTemplatesByUserByType(1);
        this.getEmailTemplatesByUserByType(2);

        //standartData
        this.getGlobalEmailTemplatesByType(1);
        this.getGlobalEmailTemplatesByType(2);
    }

    getGlobalEmailTemplatesByType(assessmentType: number) {
        this._TemplatesService.getGlobalEmailTemplatesByType(assessmentType).subscribe((data: any) => {
            console.log('response_getGlobalEmailTemplatesByType', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                if (assessmentType === 1) {
                    this.standardRegularData = _data;
                } else {
                    this.standard360Data = _data;
                }

                this.loading = false;
            }

        });
    }

    getEmailTemplatesByUserByType(assessmentType: number) {
        this._TemplatesService.getEmailTemplatesByUserByType(assessmentType).subscribe((data: any) => {

            console.log('response_GetEmailTemplatesByUserByType', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                if (assessmentType === 1) {
                    this.myTemplatesRegularData = _data;
                } else {
                    this.myTemplates360Data = _data;
                }

                this.loading = false;
            }
        });
    }

    //getEmailTemplates() {
    //    this._GetEmailTemplatesByUser.getEmailTemplatesByUser().subscribe((data: any) => {
    //        console.log('response_GetEmailTemplatesByUser', data);

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            this.data = JSON.parse(data.result.Data);
    //            setTimeout(() => {
    //                if (this.data.length == 0) {
    //                    $('#Tab1').removeClass('in active');
    //                    $('#Tab2').addClass('in active');

    //                }
    //            },10)
    //            console.log('this.data', this.data);
    //            this.loading = true;
    //        }


    //    });
    //}

    //getGlobalEmailTemplates() {
    //    this._GetGlobalEmailTemplates.getGlobalEmailTemplates().subscribe((data: any) => {
    //        console.log('response_GetGlobalEmailTemplates', data);

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            this.standardData = JSON.parse(data.result.Data);
    //            console.log('this.standardData', this.standardData);
    //            //setTimeout(() => {
    //            //    $('.containerGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
    //            //    if (this.data.length === 0) {
    //            //        $('.containerGrid .ag-body-viewport.ag-layout-normal').css('background', 'white');
    //            //    }
    //            //}, 10);
    //            this.loading = true;
    //        }
    //    });
    //}

    removeTR(event) {
        console.log(event);
        event.target.parentNode.parentElement.remove();
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi: any) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params, gridIndex) {

        switch (gridIndex) {
            case 1.1:
                this.gridApi = params.api;
                break;
            case 1.2:
                this.gridApi360 = params.api;
                break;
            case 2.1:
                this.gridApiStandard = params.api;
                this.sizeToFit(this.gridApiStandard);
                setTimeout(() => {
                    $(".ag-floating-filter-input").attr("placeholder", "Filter");
                }, 500);
                break;
            case 2.2:
                this.gridApiStandard360 = params.api;
                break;
        }
    }

    currentTab(index) {
        //this.enableFilter = false; 
        //setTimeout(() => {
        //    $('.containerGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
        //    if (this.data.length === 0) {
        //        $('.containerGrid .ag-body-viewport.ag-layout-normal').css('background', 'white');
        //    }
        //}, 10);

        console.log(index);
        this.currentSelectedTab = index;

        switch (index) {
            case 1:
            case 1.1:
                this.sizeToFit(this.gridApi);
                break;
            case 1.2:
                this.sizeToFit(this.gridApi360);
                break;
            case 2:
            case 2.1:
                this.sizeToFit(this.gridApiStandard);
                break;
            case 2.2:
                this.sizeToFit(this.gridApiStandard360);
                break;
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    createHeaders() {
        let columnDefs = new Array();

        //let actionsHeader = {
        //    headerName: 'Actions',
        //    field: '',
        //    minWidth: 85,
        //    width: 85,
        //    suppressSizeToFit: true,
        //    suppressSorting: true,
        //    suppressMenu: true,
        //    cellRenderer: function (params) {
        //        let content = '';

        //        content += '<i id="editAction" class="material-icons">edit</i>';

        //        content += '<i id="deleteAction" class="material-icons custom-icons">delete</i>';

        //        return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

        //    }
        // };
        // columnDefs.push(actionsHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let purposeHeader = {
            headerName: 'Purpose',
            field: 'Purpose',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(purposeHeader);

        let AssessmentTypeHeader = {
            headerName: 'Assessment Type',
            field: 'AssessmentType',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(AssessmentTypeHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let userTypeHeader = {
        //    headerName: 'User Type',
        //    field: 'UserType',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(userTypeHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.edit(data['Id'], false);
            //switch (e.event.target.id) {
            //    case "editAction":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.edit(data['Id']);
            //            break;
            //        }

            //    case "deleteAction":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.delete(data['Id']);
            //            break;
            //        }
            //}
        }
    }

    public onStandardRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.edit(data['Id'], true);
        }
    }

    deselectAllCheckBox() {
        this.canEdit = false;
        this.canDelete = false;
        this.gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
        this.currentRowIndex = event.rowIndex;
        console.log('currentRowIndex', this.currentRowIndex);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount == 1) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    //editSelected() {
    //    if (this.canEdit) {
    //        let selected = this.getSelectedRows();
    //        let id = selected[0].Id;
    //        let text = selected[0].Text;
    //        console.log("SELECTED ID", id);

    //        this.edit(id);
    //    }
    //}

    deleteSelected() {
        if (this.canDelete) {
            let selected = this.getSelectedRows();
            let id = selected[0].Id;
            console.log("SELECTED ID", id);

            this.delete(id);
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

    edit(id: number, isStandard: boolean) {
        console.log('edit', id);
        this.router.navigate(['/app/edit_coach_email_template', id, isStandard]);
    }

    delete(id: number) {
        console.log('delete', id);
    }

    /*STANDARD TEMPLATES*/

    standardDataCreateHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let purposeHeader = {
            headerName: 'Purpose',
            field: 'Purpose',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(purposeHeader);

        let AssessmentTypeHeader = {
            headerName: 'Assessment Type',
            field: 'AssessmentType',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(AssessmentTypeHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        return columnDefs;
    }

    ////FILTER
    //toggleFilter() {
    //    if (this.enableFilter) {
    //        $('.containerGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
    //        if (this.data.length === 0) {
    //            $('.containerGrid .ag-body-viewport.ag-layout-normal').css('background', 'white');
    //        }
    //        console.log('hide filter');
    //        this.filters.forEach((item) => {
    //            this.deselectFilter(item);
    //        });

    //    } else {
    //        $('.containerGrid .ag-body-viewport-wrapper').css({ "margin-top": "0", "position": "absolute", "width": "100%", "height": "100%" });
    //        if (this.data.length === 0) {
    //            $('.containerGrid .ag-body-viewport.ag-layout-normal').css('background', 'transparent');
    //        }
    //        console.log('show filter');
    //    }
    //    this.enableFilter = !this.enableFilter;
    //}

    //deselectFilter(filterName) {
    //    var filterComponent = this.gridApi.getFilterInstance(filterName);
    //    filterComponent.setModel(null);
    //    this.gridApi.onFilterChanged();

    //    var filterComponent = this.gridApiStandard.getFilterInstance(filterName);
    //    filterComponent.setModel(null);
    //    this.gridApiStandard.onFilterChanged();
    //}

}

